import { Outlet } from 'react-router-dom';

import Header from '../../components/Header';

import AssistantNav from './AssistantNav';
import { AssistantUserSelectionProvider } from './AssistantUserSelectionContext';

/**
 * Parent shell for the Assistant tool. Renders the header, the sub-tab
 * strip, and the active child scene via `<Outlet />`. The shell is
 * intentionally thin — every sub-tab is its own scene component so
 * they can evolve independently.
 */
const AssistantScene = () => (
  // Pinned to the viewport rather than growing with content: each sub-tab owns
  // its own scrollers, so the header, title, and tab strip stay put while a
  // long transcript or memory table scrolls beneath them. Without the bound,
  // `overflow-y-auto` on a pane is inert — the page grows instead, and anything
  // that scrolls a pane into view drags the whole document with it.
  <div className="bg-bg-primary text-fg-primary flex h-screen flex-col overflow-hidden">
    <Header />
    <main className="flex min-h-0 flex-1 flex-col gap-4 px-6 py-5">
      <div className="flex flex-col gap-1">
        <h1 className="text-sm font-semibold uppercase tracking-widest">Assistant</h1>
        <p className="text-fg-secondary text-xs">
          Inspect what the assistant has captured for a family and delete noisy or stale memories. Walk a user's thread
          history one message at a time, and hard-delete one thread or every thread on request.
        </p>
      </div>
      <AssistantNav />
      <AssistantUserSelectionProvider>
        <Outlet />
      </AssistantUserSelectionProvider>
    </main>
  </div>
);

export default AssistantScene;
